import { Pencil, Trash2, Clock } from 'lucide-react';
import { CalendarServiceType } from '../../types/calendar';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  EmptyState,
} from '../ui';

interface ServiceTypeListProps {
  serviceTypes: CalendarServiceType[];
  onEdit: (serviceType: CalendarServiceType) => void;
  onDelete: (serviceType: CalendarServiceType) => void;
  isLoading?: boolean;
}

function ServiceTypeList({ serviceTypes, onEdit, onDelete, isLoading }: ServiceTypeListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (serviceTypes.length === 0) {
    return (
      <EmptyState
        icon={<Clock className="h-12 w-12" />}
        title="Nenhum tipo de serviço cadastrado"
        description="Cadastre seu primeiro tipo de serviço para começar a agendar"
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead>Duração</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {serviceTypes.map(serviceType => (
            <TableRow key={serviceType.id}>
              <TableCell>
                <div>
                  <div className="font-medium">{serviceType.name}</div>
                  {serviceType.description && (
                    <div className="text-sm text-gray-500">{serviceType.description}</div>
                  )}
                </div>
              </TableCell>
              <TableCell>
                <div className="flex items-center">
                  <Clock className="h-4 w-4 mr-1 text-gray-500" />
                  <span>{serviceType.duration_minutes} minutos</span>
                </div>
              </TableCell>
              <TableCell className="text-right space-x-2">
                <Button variant="ghost" onClick={() => onEdit(serviceType)} title="Editar">
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button variant="ghost" onClick={() => onDelete(serviceType)} title="Excluir">
                  <Trash2 className="h-4 w-4 text-red-600" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ServiceTypeList;
